"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _more = require("@catalytic/catalytic-icons/lib/glyphs/more.svg");
var _styles = require("@material-ui/styles");
var _react2 = _interopRequireDefault(require("@tippy.js/react"));
require("tippy.js/themes/light.css");
var _ModalView = require("../../View/ModalView/ModalView");
var _excluded = ["children", "className", "opener", "openerClassName", "zIndex"]; // https://atomiks.github.io/tippyjs/#all-options
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: 0,
      borderRadius: theme.variables.borderRadiusSmall
    },
    openerContainer: {
      position: 'relative',
      display: 'inline-flex',
      cursor: 'pointer'
    },
    /**
     * Fix for Tippy/IE11 spotty support of the "contains" method on SVG nodes.
     * This gives a friendly tap-zone of IE11 browsers.
     * https://github.com/atomiks/tippyjs/issues/148
     */
    opener: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: theme.zIndex.base
    },
    openerGlyph: {
      fontSize: theme.functions.toRem(theme.variables.menuOpenerWidthEmbedded)
    }
  };
});
/*:: type Props = {
  children?: React.Node,
  className?: string,
  opener?: React.Node,
  openerClassName?: string,
  zIndex?: number
};*/
var Menu = function Menu(_ref /*:: */) {
  var children = _ref /*:: */.children,
    className = _ref /*:: */.className,
    openerProp = _ref /*:: */.opener,
    openerClassName = _ref /*:: */.openerClassName,
    zIndex = _ref /*:: */.zIndex,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  var classes = useStyles();
  var location = (0, _reactRouterDom.useLocation)();
  var modalViewContext = React.useContext(_ModalView.ModalViewContext);
  var theme = (0, _styles.useTheme)();
  var tippyInstance = React.useRef();
  var opener = openerProp || /*#__PURE__*/React.createElement(_more.ReactComponent, {
    className: classes.openerGlyph,
    "data-testid": "opener-glyph"
  });

  // Force menu to close on pathname change
  // https://github.com/catalyticlabs/triage/issues/7271
  React.useEffect(function () {
    if (tippyInstance && (0, _typeof2.default)(tippyInstance) === 'object' && tippyInstance.current && (0, _typeof2.default)(tippyInstance.current) === 'object' && typeof tippyInstance.current.hide === 'function') {
      tippyInstance.current.hide();
    }
  }, [location.pathname]);
  return /*#__PURE__*/React.createElement(_react2.default, (0, _extends2.default)({
    a11y: true,
    animateFill: false,
    animation: "shift-away",
    arrow: true,
    className: (0, _classnames.default)(classes.root, className),
    content: React.Children.map(children, function (child) {
      return React.isValidElement(child) ? React.cloneElement(child, {
        onClick: function onClick(event) {
          if (tippyInstance && (0, _typeof2.default)(tippyInstance) === 'object' && tippyInstance.current && (0, _typeof2.default)(tippyInstance.current) === 'object' && typeof tippyInstance.current.hide === 'function') {
            tippyInstance.current.hide();
          }
          if (child.props.onClick && typeof child.props.onClick === 'function') {
            child.props.onClick(event);
          }
        }
      }) : child;
    }),
    distance: 12,
    interactive: true,
    interactiveBorder: 10,
    onCreate: function onCreate(instance) {
      return tippyInstance.current = instance;
    },
    theme: "light",
    trigger: "click",
    zIndex: typeof zIndex === 'number' ? zIndex : theme && (0, _typeof2.default)(theme) === 'object' && theme.zIndex && (0, _typeof2.default)(theme.zIndex) === 'object' ? modalViewContext ? theme.zIndex.modal : theme.zIndex.menu : undefined
  }, props), /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames.default)(classes.openerContainer, openerClassName),
    "data-testid": "opener",
    onClick: function onClick(event) {
      // Trapping the click so it doesn't propagate up to the parent
      event.stopPropagation();
      event.preventDefault();
    },
    onKeyDown: function onKeyDown(event) {
      // Show menu on 'Enter'
      if (event.keyCode === 13) {
        event.target.click();
      }
    },
    role: "button",
    tabIndex: 0
  }, opener, /*#__PURE__*/React.createElement("span", {
    className: classes.opener
  })));
};
Menu.defaultProps = {
  placement: 'bottom'
};
var _default = exports.default = Menu;
//# sourceMappingURL=Menu.js.map